import { apiSlice } from './apiSlice';
import { DISCOUNTS_URL } from '../constants';
export const discountApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDiscounts: builder.query({
      query: (filters = {}) => {
        const params = {};

        if (filters?.onePerUser === 'true' || filters?.onePerUser === 'false') {
          params.onePerUser = filters.onePerUser;
        }

        return {
          url: DISCOUNTS_URL,
          params: Object.keys(params).length > 0 ? params : undefined,
        };
      },
      transformResponse: (response) => {
        if (Array.isArray(response)) return response;
        if (Array.isArray(response?.discounts)) return response.discounts;
        return [];
      },
      providesTags: (result = []) => [
        'Discount',
        ...result.map((discount) => ({ type: 'Discount', id: discount._id })),
      ],
      keepUnusedDataFor: 5,
    }),
    createDiscount: builder.mutation({
      query: (data) => ({
        url: DISCOUNTS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Discount'],
    }),
    updateDiscount: builder.mutation({
      query: ({ id, data }) => ({
        url: `${DISCOUNTS_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Discount', id }, 'Discount'],
    }),
    deleteDiscount: builder.mutation({
      query: (id) => ({
        url: `${DISCOUNTS_URL}/${id}/soft-delete`,
        method: 'PATCH',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Discount', id }, 'Discount'],
    }),
    getActiveGlobalDiscount: builder.query({
      query: () => ({
        url: `${DISCOUNTS_URL}/active-global`,
      }),
      providesTags: ['ActiveGlobalDiscount'],
    }),
  }),
});

// eslint-disable-next-line no-unused-vars
export const {
  useGetDiscountsQuery,
  useCreateDiscountMutation,
  useUpdateDiscountMutation,
  useDeleteDiscountMutation,
} = discountApiSlice;

